module.exports = __webpack_public_path__ + "img/partner-hover-2.a96fec38.png";